<template>
  <aside class="w-full h-full flex flex-col gap-6 px-2 sm:px-6 md:px-0">
    <!-- Chief Editorial -->
    <section v-reveal class="card p-5 xl:p-6">
      <div
        v-for="(section, index) in editorials"
        :key="index"
        class="group pb-6 mb-6 border-b border-gray-100 last:pb-0 last:mb-0 last:border-b-0"
      >
        <h2 class="font-serif text-xl font-bold leading-snug text-brand-red">
          {{ section.title }}
        </h2>
        <p v-if="section.subtitle" class="text-[13px] font-medium text-gray-500 mt-0.5">
          {{ section.subtitle }}
        </p>

        <div class="relative w-full h-52 mt-3 mb-4 rounded-md overflow-hidden bg-gray-100">
          <img
            :src="require(`@/assets/images/${section.image_url}`)"
            :alt="section.title"
            class="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>

        <p class="text-gray-600 text-[15px] leading-relaxed mb-3">
          {{ truncateWords(section.description, 10) }}
        </p>

        <button
          @click="
            $router.push({
              name: 'EditorialDetail',
              params: { id: section.id },
            })
          "
          class="link-arrow"
        >
          <span>Read More</span>
          <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </section>

    <!-- Vision -->
    <section
      ref="vision"
      v-reveal="{ delay: 0.1 }"
      class="card p-5 xl:p-6 group flex-1 flex flex-col"
    >
      <div class="section-heading mb-4">
        <h2 class="section-title">Vision</h2>
        <span class="section-subtitle">( দৃষ্টিভংগী )</span>
      </div>

      <!-- Designed panel (replaces the old stock photo) -->
      <div class="relative w-full flex-1 min-h-[220px] mb-4 rounded-md overflow-hidden border border-brand-cream-dark/60 bg-gradient-to-br from-brand-cream/80 via-brand-cream/35 to-white flex flex-col items-center justify-center px-6 py-8 text-center">
        <div
          class="pointer-events-none absolute -right-10 -bottom-10 h-48 w-48 bg-no-repeat bg-contain opacity-20"
          :style="`background-image: url(${visionArt})`"
        ></div>
        <div
          class="pointer-events-none absolute -left-12 -top-12 h-40 w-40 bg-no-repeat bg-contain opacity-10"
          :style="`background-image: url(${visionArt})`"
        ></div>

        <img
          :src="jaapi"
          alt=""
          class="relative h-20 w-20 drop-shadow-md transition-transform duration-[1.5s] ease-out group-hover:rotate-45"
        />
        <div class="relative mt-5 h-px w-12 bg-brand-red/60"></div>
        <p class="relative mt-4 font-serif text-xl font-bold leading-snug text-brand-red">
          সংস্কৃতিৰ স্বচ্ছ দাপোণ
        </p>
        <p class="relative mt-1 text-xs font-medium uppercase tracking-[0.2em] text-gray-500">
          Our Vision
        </p>
      </div>

      <p class="text-gray-600 text-[15px] leading-relaxed mb-4">
        সংস্কৃতি মানুহৰ জীৱন প্ৰবাহ। ই ব্যক্তি নিৰ্ভৰ নহয়, সমাজ নিৰ্ভৰ। সমাজ মানেই জনসাধাৰণ। আৰু সেইবাবেই জনসাধৰণক সংস্কৃতিৰ বিভিন্ন দিশ প্ৰত্যক্ষ কৰোৱাৰ...
      </p>

      <router-link
        to="/vision"
        class="link-arrow"
      >
        <span>Read More</span>
        <i class="fa-solid fa-arrow-right"></i>
      </router-link>
    </section>
  </aside>
</template>

<script>
import axios from "axios";
import jaapi from "@/assets/images/japi2.png";
import visionArt from "@/assets/images/art.png";

export default {
  name: "EditorialSection",
  data() {
    return {
      editorials: [],
      jaapi,
      visionArt,
    };
  },
  methods: {
    truncateWords(text, wordLimit) {
      if (!text) return "";
      const words = text.split(" ");
      if (words.length <= wordLimit) return text;
      return words.slice(0, wordLimit).join(" ") + "...";
    }
  },

  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/editorials`)
      .then((res) => {
        this.editorials = res.data;
      })
      .catch((err) => {
        console.error("Failed to fetch editorials:", err);
      });
  },
};

</script>